import { Pipe, PipeTransform } from '@angular/core'

import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range.min'
@Pipe({
    name: 'epochToTime',
    standalone: true,
})
export class EpochToTimePipe implements PipeTransform {
    transform(
        epochTime: number, // Epoch time in milliseconds
        format: string = 'h:mma', // Default format
        timezone: string = 'UTC', // Default timezone (UTC)
        trim: boolean = false,
    ): string {
        // Convert the epoch time to the given format and timezone
        if (trim) {
            return moment(epochTime).tz(timezone).format(format).slice(0, -1)
        }
        return moment(epochTime).tz(timezone).format(format)
    }
}
